import { useMemo, useState, useEffect } from "react";
import Accordion from 'react-bootstrap/Accordion';
import {SetMetaData} from './../../helper/page-title';
import ValidationHelper from "../../helper/validation";
import useInfiniteList from "../../hooks/infinite-list";
import useColumnSettings from "../../hooks/column-setting";
import InfiniteListWrapper from "../../components/wrapper/infinite-list";
import { error_api_call, post_api_call, get_api_call } from "../../actions/action-creators/common";
import { alertResponseMessage } from "../../actions/action-creators/response";
import { masterTableFieldsConf,
        fieldValuesConf,
        fieldUpdateConf,
        fieldValidationConf,
    } from "../../data/formData/glosco/sessions";
import FilterInput from "../../components/form/filter/filter-input";
import {SettingDropdownUi, RowDataUi} from "../../components/form/master-table/ui-static";
import MasterForm  from '../../components/form/master';
import normalizeFilters from "../../helper/filter/normalize-filter";
import {
  activeStatusOpp
} from "../../data/formData/option";

function GlobalConferenceSession(props) {
    SetMetaData("Manage Global Conference Sessions", "", "");
    const [filterData, setFilterData] = useState({});
    const [errorData, setErrorData] = useState({update_session: []});
    const [formSessionData, setSessionFormData] = useState({...fieldValuesConf});
    const [isProcess, setIsProcess] = useState({update_session: false});
    const [refreshKey, setRefreshKey] = useState(0);

    const { columnSettings, updateColumn } = useColumnSettings({
        session_id: true,
        school_id: true,
        active_status_id: true
    });

    const [optionData, setOptionData] = useState({
        school_id: [],
        session_id: [],
        active_status_id: activeStatusOpp,
    });

    const normalizedFilter = useMemo(
    () =>
        normalizeFilters(filterData, {
            school_id: "id",
            active_status_id: "id",
            session_id: "id"
        }),
        [filterData]
    );

    const memoizedPayload = useMemo(() => ({
        fetch_type: "global_session",
        filter: normalizedFilter
    }), [normalizedFilter]); // Only changes when filters change

    const {
        data,
        fetchNextPage,
        hasNextPage,
        isFetchingNextPage,
        isLoading
    } = useInfiniteList({
        queryKey: ["global_session", refreshKey],
        apiCall: payload => {
            return post_api_call("glosco-conference-sessions", payload)
        },
        limit: 100,
        // extraPayload: {
        //     fetch_type: "global_session",
        //     filter: normalizedFilter
        // }
        extraPayload: memoizedPayload, // Use the memoized version
    });

    // const masterTableData = data?.pages.flatMap(page => page.data) ?? [];
    const masterTableData = Array.isArray(data?.pages)
                            ? data.pages.flatMap(page => Array.isArray(page?.data) ? page.data : [])
                            : [];
    // const visibleUserIds = masterTableData.map(r => r.id);

    //Get Data from APIs
    const fetchSelectList = async(type, url) => {
      try{
          const selectApiData = await get_api_call(url, {});
          var data = [];
          if(selectApiData.status === 200){
              data = selectApiData.data;
              switch (type) {
                  case 'manage_conf_session':
                    setOptionData({...optionData,
                        school_id: [{id: -1, school_name: "For All Schools"}, ...data?.schools],
                        session_id: data?.sessions_conf,
                    });
                    break;
                  default: 
              }
          }
          return {
              data
          };
      }catch(error){
        error_api_call({error: `admin|screens|glosco|global-conference-session|fetchSelectList|${error}`});
        return {data: []};
      }
    }

    useEffect(() => {
        if(props.userRoleIds.includes(2)
            || props.userRoleIds.includes(7)
        ){
            fetchSelectList('manage_conf_session', 'dropdown-options/manage-glosco-conf-session');
        }
    }, [props?.userRoleIds]);// eslint-disable-line react-hooks/exhaustive-deps

    const updateInput = (form_type, attrName, value) => {
        try {
            if(form_type === "update_session") {
                if(errorData[form_type].length){
                    setErrorData({...errorData, [form_type]: []});
                }
                
                let fields = {...formSessionData};
                if (attrName === "school_ids") {
                    const hasForAll = value.some(v => v.id === -1);
                    // const hasOtherSchools = value.some(v => v.id !== -1);
                    if(hasForAll) {
                        fields.school_ids = value.filter(v => v.id === -1);
                    } else {
                        fields.school_ids = value;
                    }
                }else{
                    fields[attrName] = value;
                }
                setSessionFormData({...fields});
            }else if(form_type === "filter"){
                let fields = {...filterData};
                fields[attrName] = value;
                setFilterData({...fields});
            }
        } catch (error) {
            console.error(error);
            error_api_call({
                error: `admin|screens|glosco|global-conference-session|updateInput|${error}`
            });
        }
    };
    //Submit Details
    const submitForm = async(e, form_type='') => {
        try{
            e.preventDefault();
            setErrorData({...errorData, [form_type]: []});
            setIsProcess({...isProcess, [form_type]: true});
            var errorDetails = [];
            var apiFormData = new FormData();
            //Validation
            var validation = [];
            var inputData = {};
            var validationFields = {};
            switch (form_type) {
                case 'update_session':
                    inputData = {...formSessionData};
                    validationFields = fieldValidationConf;
                    break;
                default:
            }
            validation = ValidationHelper.validation(inputData, validationFields).error;
            if(validation.length){
                errorDetails = validation;
            }
          
            if(errorDetails.length > 0){
                setErrorData({...errorData, [form_type]: errorDetails});
                setIsProcess({...isProcess, [form_type]: false});
                // setBtnDisabled({...isBtnDisabled, [form_type]: true});
            }else{
                //Send Data to Server
                var api = '';
                switch (form_type) {
                    case 'update_session':
                        api = 'glosco/update/glosco-conf-sessions';
                        apiFormData.append('session', inputData.session);

                        inputData.school_ids.forEach(school => {
                            apiFormData.append("school_ids[]", Number(school.id));
                        });
                        break;
                    default:
                }

                const updateOppor = await post_api_call(`${api}`, apiFormData);
                if(updateOppor.status === 200){
                    alertResponseMessage({alert_type: 1, message: "Information Updated Successfully"});
                    // setBtnDisabled({...isBtnDisabled, [form_type]: true});
                    setSessionFormData({...fieldValuesConf});
                    setRefreshKey(prev => prev + 1); //RESET TABLE
                }else{
                    if(typeof updateOppor.message !== "undefined"){
                        setErrorData({...errorData, [form_type]: [updateOppor.message]});
                    }
                }
                setIsProcess({...isProcess, [form_type]: false});
            }
          
        }catch(error){
            console.error(error);
            setErrorData({...errorData, [form_type]: ['Something Went Wrong, Please Try After Some Time']});
            setIsProcess({...isProcess, [form_type]: false});
            error_api_call({error: `admin|screens|glosco|global-conference-session|submitForm|${error}`});
        }
    }
    //Update Status
    const updateStatus = async(e, type, data) => {
        e.preventDefault();
        try{
          // status_change
          if (window.confirm(`${data.active_status_id === 1 ? 'Deactivate' : 'Activate'} Session?`)){
            const targetTag = e.target.tagName.toLowerCase();
            if(targetTag === 'i'){
                e.target.parentElement.disabled = true;
            }else{
                e.target.disabled = true;
            }
            const statusApiData = await post_api_call(`glosco/update/glosco-conf-status`,
                                    {...data,
                                        active_status_id: data.active_status_id === 2 ? 1 : 2
                                    });
            if(statusApiData.status === 200){
                setRefreshKey(prev => prev + 1); //RESET TABLE
                alertResponseMessage({alert_type: 1, message: `Session ${data.active_status_id === 1 ? 'Deactivated' : 'Activated'} Successfully!`});
            }
            if(targetTag === 'i'){
                e.target.parentElement.disabled = false;
            }else{
                e.target.disabled = false;
            }
          }
        }catch(error){
            const targetTag = e.target.tagName.toLowerCase();
            if(targetTag === 'i'){
                e.target.parentElement.disabled = false;
            }else{
                e.target.disabled = false;
            }
          error_api_call({error: `admin|screens|glosco|updateStatus|${error}`});
        }
    }

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card p-2 mb-2 mod-custom z-index-99999">
                    <Accordion
                        className="filter-custom"
                    >
                        <Accordion.Item eventKey="1">
                            <Accordion.Header>
                                Update Sessions
                            </Accordion.Header>
                            <Accordion.Body className="p-2">
                                <MasterForm
                                    formType={'update_session'}
                                    data={formSessionData}
                                    _errorData={{...errorData}}
                                    _isProcess={{...isProcess}}
                                    // _isBtnDisabled={{...isBtnDisabled}}
                                    _updateInput= {(form_type, variable_type, input_type, field, value) => updateInput(form_type, field, value)}
                                    _submitForm={(e, form_type) => submitForm(e, form_type)}
                                    _formData={[{form_type: 'update_session',
                                                label: "Sessions",
                                                fields: [...fieldUpdateConf]}
                                            ]}
                                    selectOptions={{school_ids:{
                                                        value: 'id',
                                                        label: 'school_name',
                                                        data: [...optionData.school_id],
                                                    }}
                                                }
                                />
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </div>
            </div>

            <InfiniteListWrapper
                dataLength={masterTableData.length}
                isLoading={isLoading}
                hasNextPage={hasNextPage}
                fetchNextPage={fetchNextPage}
                isFetchingNextPage={isFetchingNextPage}
                emptyMessage="No Record found!"
            >
                <div className="col-lg-12 grid-margin stretch-card">
                    <div className="card">
                        {/* SETTINGS */}
                        <SettingDropdownUi
                            checkedData={columnSettings}
                            fields={masterTableFieldsConf}
                            updateColumn= {(field, value) => updateColumn(field, value)}
                        />

                        {/* TABLE */}
                        <div className="card-body table-responsive sticky-table pt-0 pe-0 ps-3">
                            <table className="table">
                                <thead>
                                <tr>
                                    {masterTableFieldsConf.map((col, i) => (
                                    (typeof col.accessRoleIds === "undefined" ||
                                        props.userRoleIds.some(role =>
                                        col.accessRoleIds.includes(role)
                                        )) &&
                                        columnSettings[col.field.name] && (
                                            <th key={i} className={`w-200p ${col.class_name || ""}`}>
                                            {col.title}
                                            {col.is_searchable && (
                                                <FilterInput
                                                    formType="filter"
                                                    field={col?.field}
                                                    data={filterData}
                                                    selectOptions={
                                                        (col.field?.type === "multi-select"
                                                        || col.field?.type === "select")
                                                        ?
                                                            {[col.field?.name]: {
                                                                value: col?.option_val,
                                                                label: col?.option_label,
                                                                data: optionData[col.field?.name]
                                                            }}
                                                        :
                                                            {}
                                                        }
                                                    _updateInput= {(form_type, data_type, input_type, field, value) => updateInput(form_type, field, value)}
                                                />
                                            )}
                                            </th>
                                        )
                                    ))}
                                    <th>Action</th>
                                </tr>
                                </thead>

                                <tbody>
                                {isLoading ? (
                                    <tr>
                                        <td colSpan="20" className="text-center p-4">
                                            <img
                                                alt="Loader"
                                                src={require("../../assets/images/Image-Loader.gif")}
                                            />
                                        </td>
                                    </tr>
                                ) : (
                                    masterTableData.length > 0 
                                    ? (
                                        masterTableData.map((row, index) => {
                                        return (
                                            <tr
                                                key={index}
                                            >

                                                {masterTableFieldsConf.map((tbl, i) => (
                                                    (typeof tbl.accessRoleIds === "undefined" ||
                                                    props.userRoleIds.some(role =>
                                                        tbl.accessRoleIds.includes(role)
                                                    )) &&
                                                    columnSettings[tbl.field.name] && (
                                                    <td key={i}>
                                                        {/* {row[tbl.fetch_key]} */}
                                                        <RowDataUi
                                                            fetch_key={tbl.fetch_key}
                                                            data={row}
                                                        />
                                                    </td>
                                                    )
                                                ))}

                                                <td>
                                                    <button
                                                        onClick={(e) => updateStatus(e,
                                                                            'status_change',
                                                                            {active_status_id: row.active_status_id,
                                                                            id: row.id,
                                                                            type: row.for_all,
                                                                            session_id: row.session_id
                                                                            }
                                                                        )}
                                                        className={`btn btn-sm ms-2
                                                                    ${row.active_status_id === 1
                                                                        ? 'btn-danger'
                                                                        : 'btn-success'}`}
                                                        title={row.active_status_id === 1
                                                                ? 'Deactivate'
                                                                : 'Activate'}
                                                    ><i className="mdi mdi-check-outline"></i></button>
                                                </td>
                                            </tr>
                                        );
                                        })
                                    )
                                    : 
                                    <tr>
                                        {/* <td colSpan={props.userRoleIds.includes(2) ? 13 : 11}> */}
                                        <td colSpan="20">
                                        <div className="no-fellow text-center mt-4">
                                            {/* {emptyImage && <img src={emptyImage} alt="No Data" />} */}
                                            <p className="pt-4 head">{"No Record Found!"}</p>
                                        </div>
                                        </td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </InfiniteListWrapper>
        </div>
    );
}

export default GlobalConferenceSession;